import { render, staticRenderFns } from "./UserProfileLayout.vue?vue&type=template&id=68cdbc12&scoped=true"
import script from "./UserProfileLayout.js?vue&type=script&lang=js&external"
export * from "./UserProfileLayout.js?vue&type=script&lang=js&external"
import style0 from "./UserProfileLayout.vue?vue&type=style&index=0&id=68cdbc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cdbc12",
  null
  
)

export default component.exports